import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobeauditionComponent } from './simple-icons-adobeaudition.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobeauditionComponent ],
    exports:      [ SimpleIconsAdobeauditionComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobeauditionModule {}
